import React from 'react';

export const SearchBar = ({ value, onChange, placeholder }) => (
  <div className="mb-3">
    <input
      type="text"
      className="form-control"
      placeholder={placeholder || 'Search networks...'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
